import { createFileRoute } from "@tanstack/react-router";
import CheckoutCancel from "@/pages/CheckoutCancel";
import { buildNoindexHead, noindexLoader, type NoindexSEO } from "@/lib/noindex-route-seo";

const TITLES: NoindexSEO = {
  "es": "Pago cancelado",
  "pt-BR": "Pagamento cancelado",
  "en": "Payment canceled",
  "en-EU": "Payment canceled",
};

export const Route = createFileRoute("/checkout/cancel")({
  loader: noindexLoader,
  head: ({ loaderData }) => buildNoindexHead(TITLES, "/checkout/cancel", loaderData),
  component: CheckoutCancel,
});
